module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.smallImage,
      "media": "(max-width: 697px)"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.image,
      "alt": _vm.alt
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-36cf9d36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PictureLoader.vue
// module id = 98
// module chunks = 4